<template>
  <div class="flex flex-col items-center gap-4 md:flex-row md:items-end">
    <div class="flex flex-wrap items-end justify-center gap-4 place-self-start lg:justify-start">
      <div class="flex w-full max-w-xs flex-col sm:w-60">
        <label for="estados-uso" class="text-sm font-medium tracking-wide text-gray-700">
          <span>Delegación</span>
        </label>
        <select
          class="w-full appearance-none truncate transition duration-150 ease-in-out sm:text-sm"
          type="text"
          id="estados-uso"
          v-model="filtros.sede_id"
        >
          <option :value="null">Todas las delegaciones</option>
          <option v-for="sede in sedes" :key="sede.id" :value="sede.id.trim()">
            {{ sede.descripcion }}
          </option>
        </select>
      </div>
      <div class="flex w-full max-w-xs flex-col items-center">
        <div class="text-sm font-medium tracking-wide text-gray-700">Fecha de creación</div>
        <div class="flex w-full space-x-2">
          <datetime
            class="theme-colescba relative grow"
            type="date"
            input-id="creacion-desde"
            placeholder="Fecha desde"
            input-class="block w-full sm:text-sm  transition duration-150 ease-in-out"
            v-model="filtros.fechaCreacion.desde"
            zone="America/Argentina/Buenos_Aires"
            value-zone="America/Argentina/Buenos_Aires"
            format="dd/MM/yyyy"
            :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
            :min-datetime="minDateFrom"
            :max-datetime="maxDateCreacionFrom"
          >
            <template #after>
              <div class="absolute right-2 top-0 flex h-full items-center">
                <SolidXIcon
                  class="h-4 w-4 cursor-pointer text-gray-400"
                  @click="filtros.fechaCreacion.desde = null"
                />
              </div>
            </template>
          </datetime>
          <datetime
            class="theme-colescba relative grow"
            type="date"
            input-id="creacion-hasta"
            placeholder="Fecha hasta"
            input-class="block w-full sm:text-sm  transition duration-150 ease-in-out"
            v-model="filtros.fechaCreacion.hasta"
            zone="America/Argentina/Buenos_Aires"
            value-zone="America/Argentina/Buenos_Aires"
            format="dd/MM/yyyy"
            :phrases="{ ok: 'Aceptar', cancel: 'Cancelar' }"
            :min-datetime="minDateCreacionTo"
            :max-datetime="maxDateTo"
          >
            <template #after>
              <div class="absolute right-2 top-0 flex h-full items-center">
                <SolidXIcon
                  class="h-4 w-4 cursor-pointer text-gray-400"
                  @click="filtros.fechaCreacion.hasta = null"
                />
              </div>
            </template>
          </datetime>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <button
        @click="$emit('change:filter', filtros)"
        class="inline-flex flex-1 items-center justify-center space-x-2 rounded-md border border-blue-brand-500 bg-white px-3 py-2 text-base font-medium text-blue-brand-500 shadow-sm transition duration-150 ease-in-out hover:bg-blue-brand-100 hover:text-blue-brand-500 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-300 active:text-blue-brand-500 sm:text-sm"
      >
        <span>Aplicar</span>
      </button>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import moment from 'moment'

export default {
  data() {
    return {
      sedes: [],
      rangoValido: {
        desde: moment().subtract(365, 'd'),
        hasta: moment().add(30, 'd'),
      },
      filtros: {
        sede_id: null,
        fechaCreacion: {
          desde: null,
          hasta: null,
        },
      },
    }
  },

  mixins: [useService('portalPagos'), useSession()],

  async mounted() {
    this.sedes = await this.portalPagos.getSedes(this.user.cuitCuil.numero)
    this.filtros.fechaCreacion.desde = moment().startOf('month').toISOString()
    this.filtros.fechaCreacion.hasta = moment().endOf('month').toISOString()
    this.$emit('change:filter', this.filtros)
  },

  computed: {
    minDateFrom() {
      return this.rangoValido.desde.toISOString()
    },
    maxDateCreacionFrom() {
      let momentDate = this.filtros.fechaCreacion.hasta
        ? moment(this.filtros.fechaCreacion.hasta)
        : this.rangoValido.hasta
      return momentDate.toISOString()
    },
    minDateCreacionTo() {
      let momentDate = this.filtros.fechaCreacion.desde
        ? moment(this.filtros.fechaCreacion.desde)
        : this.rangoValido.desde
      return momentDate.toISOString()
    },
    maxDateTo() {
      return this.rangoValido.hasta.toISOString()
    },
  },
}
</script>
<style scoped>
input[type='date'] {
  display: inline-block;
  position: relative;
}

input[type='date']::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}
</style>
<style>
.vdatetime-popup {
  height: 490px;
  overflow: auto;
}

.vdatetime-popup__actions {
  position: absolute;
  bottom: 0;
  right: 0;
}

.vdatetime-calendar__navigation {
  user-select: none;
}
</style>
